export const dropDownStyle = {
  fontSize: 12,
  color: 'green',
  fontWeight: 'bold',
};

export const triggerEvent = window.matchMedia('(hover: hover)').matches
  ? ['hover', 'focus']
  : ['focus'];
